import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import {
    compose,
    branch,
    renderComponent,
    getContext,
    renderNothing,
    lifecycle
} from 'recompose';
import { loadContact } from '../Contact/ContactActions';
import { ContactContainerProps } from './ContactTypes';

// presentation components
import ContactPanel, { LoadingContact } from './ContactPanelComponent';
import { getContactData } from './ContactSelector';

const mapStateToProps = (state, props) => ({
    contact: getContactData(state, props),
    contactStore: state.contactStore
});

const mapDispatchToProps = (dispatch, ownProps: ContactContainerProps) => ({
    loadContactPanelData() {
        const { session, banId, contactId } = ownProps;

        dispatch(loadContact(session, banId, contactId));
    }
});

const isLoading = ({ contactStore }) => contactStore.loading;
const hasError = ({ contactStore }) => contactStore.error;

const LoadingRender = renderComponent(LoadingContact);

const ContactContainer = compose(
    getContext({
        session: PropTypes.any.isRequired,
        isOnCallList: PropTypes.bool,
    }),
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle<ContactContainerProps, {}>({
        componentDidMount() {
            this.props.loadContactPanelData();
        },
        componentDidUpdate(prevProps: ContactContainerProps) {
            const { contactId, loadContactPanelData } = this.props;

            if (contactId && contactId !== prevProps.contactId) {
                loadContactPanelData();
            }
        }
    }),
    branch(isLoading, LoadingRender),
    branch(hasError, renderNothing)
);

export default ContactContainer(ContactPanel) as React.ComponentClass<ContactContainerProps>;



// WEBPACK FOOTER //
// ./src/sections/Contact/index.ts